export const PAGE_QUERY = 'page';
export const ITEMS_PER_PAGE_QUERY = 'itemsPerPage';
export const SEARCH_QUERY = 'search';
export const FROM_DATE_QUERY = 'from';
export const TO_DATE_QUERY = 'to';
export const TAB_QUERY = 'tab';
